import HttpConfig from './HttpConfig'
class HttpInterceptorManager {

	constructor(){
		this.interceptors = [];
	}

	addInterceptor(interceptor) {
		this.interceptors.push(interceptor);
	}

	runInterceptorsMethod(method, param) {
		let retVal = new HttpConfig(param);
		this.interceptors.forEach((interceptor)=> {
			if(interceptor[method]) {
				retVal = interceptor[method].call(null, retVal);
			}
		});
		return retVal;
	}
}

export default new HttpInterceptorManager();


// WEBPACK FOOTER //
// ../common/utils/http/interceptor.js